/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import jQuery from "jquery";
require("bootstrap");

import wp from "./wp";
import utils from "./utils";
import modules from "./modules";
import Glide from "@glidejs/glide";

(function($) {
  window.basePath = "/wp-content/themes/papername.com/build";
  window.globalToast = utils.globalToast;
  require("./modules/reactApp");
  require("./utils/Header");
  require("./utils/CustomDropdown");
  require("./utils/FaqAccordion");
  require("./Slider");
  modules.NoticesWrapper.init($);
  
  $(document).ready(function() {
    //Slider Hero
    let slider = document.querySelector(".glide");
    if (slider) {
      let glide = new Glide(".glide", {
        type: "carousel",
      });
      glide.mount();
    }

    if (window.location.pathname.includes("instagram-authenticator")) {
      let IGRedirect = new utils.InstagramRedirect();
      IGRedirect.handleRedirect();
    }

    // //Slider Testimonials
    // let testimonials = document.querySelector(".testimonials");
    // if (testimonials) {
    //   let glide = new Glide(".testimonials", {
    //     type: "carousel",
    //     perView: 2,
    //     gap: 20,
    //     autoplay: 2500,
    //     breakpoints: {
    //       768: {
    //         perView: 1,
    //       },
    //     },
    //   });
    //   glide.mount();
    // }

    $(document).on("show.bs.modal", "#product-image-cropper-modal", function() {
      $(this)
        .find(".modal-body")
        .toggleClass("opacity-0");
    });

    $(document).on(
      "shown.bs.modal",
      "#product-image-cropper-modal",
      function() {
        handCropModalChildTransform();
        $(this)
          .find(".modal-body")
          .toggleClass("opacity-0");
      }
    );
  });

  $(".shopping-checkout__invoice-title").click(function() {
    $(".shopping-checkout__wrap-invoice").toggleClass("invoice-hidden");
  });
})(jQuery);

function handCropModalChildTransform() {
  var margin = 0;
  var modal = document.querySelector("#product-image-cropper-modal");
  var modalBody = modal.querySelector(".modal-body");
  var modalBodyWidth = modalBody.getBoundingClientRect().width - margin * 2;
  var modalBodyHeight = modalBody.getBoundingClientRect().height - margin * 2;
  var cropper = modalBody.querySelector(".js-cropper-wrapper");
  var cropperWidth = cropper.getBoundingClientRect().width;
  var cropperHeight = cropper.getBoundingClientRect().height;
  var coef = modalBodyWidth / cropperWidth;
  if (Math.floor(modalBodyHeight / coef) != Math.floor(cropperHeight)) {
    modalBody.style.height = "" + Math.floor(cropperHeight * coef) + "px";
    modalBody.style.margin = "" + margin + "px";
    cropper.style.transformOrigin = "top left";
    cropper.style.transform = "scale(" + coef + ")";
  }
}
